export class InfoBox {

	static close(caller) {
		caller.closest('.js-info-box').classList.remove('active');
		return false;
	}

}

window.InfoBox = InfoBox;
